module.exports = __webpack_public_path__ + "static/media/icon-story-light.e12c6bed.svg";